import React from 'react'
import Select from 'react-select'
import { useState, useEffect, memo } from 'react';


//entrada esperada
/*
const options = [
  { value: 'chocolate', label: 'Chocolate' },
  { value: 'strawberry', label: 'Strawberry' },
  { value: 'vanilla', label: 'Vanilla' }
]
*/

/*
closeMenuOnSelect={false}
      components={animatedComponents}
      defaultValue={[colourOptions[4], colourOptions[5]]}
      isMulti
      options={colourOptions}

      // seleccion multi, este sera usado para seleccionar la opcion que tenga el usuairo o el tablero de un gurpo de tableros
      defaultValue={[options[0], options[2]]}
*/

const Select2 = (params) => {


  const _onChange = (data) => {
    params.set_data(data)
  }

  if (typeof params.multi !== undefined) {

    if (params.multi === true) {

      if (typeof params.selects !== undefined) {

        return (
          <Select options={params.options} defaultValue={params.selects} onChange={_onChange} isMulti placeholder=".:Selecciona:." />
        )

      }

      return (
        <Select options={params.options} onChange={_onChange} isMulti placeholder=".:Selecciona:." />
      )

    }

    return (
      <Select options={params.options} onChange={_onChange} placeholder=".:Selecciona:." />
    )
  } else {

    if (typeof params.selects !== undefined) {

      return (
        <Select options={params.options} defaultValue={params.selects} onChange={_onChange} placeholder=".:Selecciona:." />
      )

    }

    return (
      <Select options={params.options} onChange={_onChange} placeholder=".:Selecciona:." />
    )

  }

}


export default memo(Select2);